// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SmartTextareaInput":"bfv_a bhh_vb bhh_vp bhh_xf bhh_vh"};